import { useRef, useState, useCallback } from 'react'
import { QRCodeSVG } from 'qrcode.react'

interface SurveyQrCodeProps {
  url: string
  surveyName: string
}

export default function SurveyQrCode({ url, surveyName }: SurveyQrCodeProps) {
  const [showModal, setShowModal] = useState(false)
  const dialogRef = useRef<HTMLDialogElement>(null)
  const canvasRef = useRef<HTMLDivElement>(null)

  function openModal() {
    setShowModal(true)
    dialogRef.current?.showModal()
  }

  const handleDownload = useCallback(() => {
    const svg = canvasRef.current?.querySelector('svg')
    if (!svg) return

    const canvas = document.createElement('canvas')
    const size = 1024
    canvas.width = size
    canvas.height = size
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    const svgData = new XMLSerializer().serializeToString(svg)
    const img = new Image()
    img.onload = () => {
      ctx.fillStyle = '#ffffff'
      ctx.fillRect(0, 0, size, size)
      ctx.drawImage(img, 0, 0, size, size)

      const a = document.createElement('a')
      a.download = `${surveyName.replace(/[^a-z0-9]/gi, '_').toLowerCase()}_qr.png`
      a.href = canvas.toDataURL('image/png')
      a.click()
    }
    img.src = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svgData)))
  }, [surveyName])

  return (
    <>
      <button
        type="button"
        onClick={openModal}
        className="btn btn-sm btn-ghost"
        title="Show QR code"
      >
        <span className="iconify lucide--qr-code size-4" />
        QR Code
      </button>

      {showModal && (
        <dialog ref={dialogRef} className="modal" onClose={() => setShowModal(false)}>
          <div className="modal-box max-w-sm text-center">
            <form method="dialog">
              <button className="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
                <span className="iconify lucide--x size-4" />
              </button>
            </form>

            <h3 className="font-bold text-lg mb-1">Scan to open survey</h3>
            <p className="text-sm text-base-content/60 mb-4">
              Display this on a slide for participants to scan with their phone.
            </p>

            <div ref={canvasRef} className="flex justify-center mb-4">
              <QRCodeSVG
                value={url}
                size={256}
                level="M"
                marginSize={2}
              />
            </div>

            <p className="text-xs text-base-content/40 break-all mb-4">{url}</p>

            <button
              type="button"
              onClick={handleDownload}
              className="btn btn-primary btn-sm"
            >
              <span className="iconify lucide--download size-4" />
              Download PNG
            </button>
          </div>
          <form method="dialog" className="modal-backdrop">
            <button>close</button>
          </form>
        </dialog>
      )}
    </>
  )
}
